import siteApi from '../clients/site';
import tenantApi from '../clients/tenant';

export const generateSiteSearchKey = async (): Promise<string> => {
  const { data } = await siteApi.post<string>('/generate-search-key');

  return data;
};

export const generateTenantSearchKey = async (): Promise<string> => {
  const { data } = await tenantApi.post<string>('/generate-search-key');

  return data;
};
